import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../components/landing/HeroSection';
import LiveDemosSection from '../components/landing/LiveDemosSection';
import ProductsSection from '../components/landing/ProductsSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import LandingHeader from '../components/landing/LandingHeader';
import LandingFooter from '../components/landing/LandingFooter';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace(/^#/, '');
    // Allow layout paint before scrolling to anchored sections from other pages.
    const t = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
    return () => window.clearTimeout(t);
  }, [location.hash, location.pathname]);

  return (
    <div className="landing-page">
      <LandingHeader />
      <HeroSection />
      <LiveDemosSection />
      <ProductsSection />
      <FeaturesSection />
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
